export default __webpack_public_path__ + "static/media/desc-bg-smm.107d321e.svg";